import {computed, ref} from "vue";
import {ErrorInterface} from "@/api/apiService";
import {isUndefined} from "lodash";

export function useFormError(fields: string[]) {

  const getErrors = () => fields.reduce((acc, field) => {
    acc[field] = '';
    return acc;
  }, {} as Record<string, string>);

  const errors = ref<Record<string, string>>(getErrors());

  const hasError = computed(() => Object.values(errors).some((m) => m.length > 0));

  function clearErrors() {
    errors.value = getErrors();
  }

  function applyErrorResponse(errorInterface: ErrorInterface) {
    const invalidEntries = errorInterface?.publicResponse?.invalidEntries ?? [];
    for (const entry of invalidEntries) {
      if (!isUndefined(errors.value[entry.field])) {
        errors.value[entry.field] = entry.message;
      }
    }
  }

  return {
    errors,
    hasError,
    clearErrors,
    applyErrorResponse,
  };

}
